import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("测试")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("箱子")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("模拟")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_SimulationModal = _resolveComponent("SimulationModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.newBoxInfo,
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "box_category_id",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.box_category_id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.box_category_id) = $event)),
                placeholder: "目录",
                filterable: "",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.box_categories, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.name,
                      value: item.id,
                      key: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "box_type",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.box_type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.box_type) = $event)),
                placeholder: "消费类型",
                filterable: "",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.box_types, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.key,
                      value: item.value,
                      key: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "game_type",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.game_type,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.game_type) = $event)),
                placeholder: "游戏类型",
                filterable: "",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game_types, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.key,
                      value: item.value,
                      key: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "name",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.name) = $event)),
                placeholder: "名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "is_crash",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.is_crash,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.is_crash) = $event)),
                placeholder: "崩盘补偿",
                clearable: "",
                style: {"width":"120px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "是",
                    value: true
                  }),
                  _createVNode(_component_el_option, {
                    label: "否",
                    value: false
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "is_increase_membership_point",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.is_increase_membership_point,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.is_increase_membership_point) = $event)),
                placeholder: "积分累计",
                clearable: "",
                style: {"width":"120px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "是",
                    value: true
                  }),
                  _createVNode(_component_el_option, {
                    label: "否",
                    value: false
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "enabled",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.enabled,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.enabled) = $event)),
                placeholder: "启用状态",
                clearable: "",
                style: {"width":"120px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "启用",
                    value: true
                  }),
                  _createVNode(_component_el_option, {
                    label: "停用",
                    value: false
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onCancel
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID",
          width: "60"
        }),
        _createVNode(_component_vxe_column, {
          title: "图片",
          width: "60"
        }, {
          default: _withCtx(({ row }) => [
            (row.image_url)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  src: row.image_url,
                  "preview-src-list": [row.image_url],
                  fit: "cover",
                  style: {"width":"40px","height":"53px","border-radius":"4px"},
                  "preview-teleported": ""
                }, null, 8, ["src", "preview-src-list"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "box_category",
          title: "目录",
          width: "100"
        }),
        _createVNode(_component_vxe_column, {
          title: "消费类型",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, {
              type: _ctx.getBoxTypeTag(row.box_type),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.box_type_display), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "游戏类型",
          width: "90"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, {
              type: _ctx.getGameTypeTag(row.game_type),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.game_type_display), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "name",
          title: "名称",
          "min-width": "120"
        }),
        _createVNode(_component_vxe_column, {
          title: "价格",
          width: "70"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatPrice(row.price)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "total_quantity",
          title: "抽数",
          width: "70"
        }),
        _createVNode(_component_vxe_column, {
          title: "总金额",
          width: "90"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.total_amount), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "总成本",
          width: "90"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.total_item_amount), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "利润比",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", {
              style: _normalizeStyle({ color: _ctx.getProfitColor(row.profit_amount) })
            }, _toDisplayString(row.profit_percent), 5)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "启用",
          width: "70"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, {
              type: row.enabled ? 'success' : 'danger',
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.enabled ? "启用" : "停用"), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "测试",
          width: "60"
        }, {
          default: _withCtx(({ row }) => [
            (row.is_test)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "updated_at",
          title: "更新时间",
          width: "160"
        }),
        _createVNode(_component_vxe_column, {
          field: "updated_by",
          title: "更新人",
          width: "80"
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "210",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'box_info_edit', params: { id: row.id } }))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'boxes', params: { id: row.id } }))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (row.game_type === 'infinity' || row.game_type === 'level')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "warning",
                  size: "small",
                  onClick: ($event: any) => (_ctx.openSimulation(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"]),
    _createVNode(_component_SimulationModal, {
      visible: _ctx.simulationVisible,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.simulationVisible) = $event)),
      boxInfo: _ctx.simulationBoxInfo
    }, null, 8, ["visible", "boxInfo"])
  ]))
}